// frontend/src/components/HomepageInfoSections.js
// Marketing-information sections shown above the homepage footer, blending the
// premium content from the landing page, /how-it-works, /for-businesses,
// /for-professionals and /freelancer pages into the marketplace homepage.

import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarCheck,
  FaShoppingBag,
  FaShieldAlt,
  FaCamera,
  FaCheckCircle,
} from "react-icons/fa";
import "./HomepageInfoSections.css";

const features = [
  {
    icon: <FaCalendarCheck />,
    title: "Book in real time",
    desc: "Salons, studios and independent pros with live availability — book without the back-and-forth.",
  },
  {
    icon: <FaShoppingBag />,
    title: "Book & buy together",
    desc: "Browse each storefront's products and add them to the same visit for in-shop pickup.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Pay securely",
    desc: "Bookings and products are paid securely through Stripe — card details are never stored.",
  },
  {
    icon: <FaCamera />,
    title: "Looks turn into bookings",
    desc: "Finished work becomes a shareable, bookable style — every shared Look links straight back to booking you.",
  },
];

const trust = [
  "Verified salons & professionals",
  "Real-time availability",
  "Secure payments by Stripe",
  "Automatic confirmations & reminders",
  "Shop products from every storefront",
];

export default function HomepageInfoSections() {
  return (
    <section className="his" aria-label="How OGESTYLE works">
      {/* Why OGESTYLE */}
      <div className="his-sec his-sec--white">
        <div className="his-wrap">
          <div className="his-head">
            <p className="his-eyebrow">Why OGESTYLE</p>
            <h2 className="his-title">
              One calm place for the whole visit
            </h2>
            <p className="his-sub">
              OGESTYLE brings clients, salons, studios and independent
              professionals together — booking, products, Looks and payments in
              one connected flow.
            </p>
          </div>

          <div className="his-feat">
            {features.map((f) => (
              <article className="his-feat-card" key={f.title}>
                <span className="his-ic">{f.icon}</span>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>

      {/* Looks */}
      <div className="his-sec his-sec--cream">
        <div className="his-wrap">
          <div className="his-looks">
            <div className="his-looks-copy">
              <p className="his-eyebrow">Looks</p>
              <h2 className="his-title">Turn your work into bookings</h2>
              <p className="his-sub his-looks-sub">
                Finished services become a look — a beautiful share card that
                clients and followers can post anywhere. Every share links
                straight back to booking you.
              </p>
              <ul className="his-looks-list">
                <li>
                  <FaCheckCircle /> Shareable by anyone &mdash; not just you
                </li>
                <li>
                  <FaCheckCircle /> Every share links back to booking
                </li>
                <li>
                  <FaCheckCircle /> Free exposure for your work
                </li>
              </ul>
              <Link to="/looks/all" className="his-looks-cta">
                See real Looks &rarr;
              </Link>
            </div>
            <div className="his-looks-media">
              <img
                src="/landing/looks.jpg"
                alt="A finished OGESTYLE Look that clients can book"
              />
              <div className="his-looks-badge">
                <FaCamera />
                <span>From finished service to bookable style</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div className="his-cta">
        <div className="his-wrap">
          <p className="his-eyebrow">Book &amp; buy in one step</p>
          <h2 className="his-title">
            Your next visit starts with a search
          </h2>
          <p className="his-sub">
            Discover nearby salons, spas, barbers and independent pros — book a
            service, shop their products, or start running your own beauty
            business today.
          </p>

          <div className="his-cta-btns">
            <Link to="/shops" className="his-btn his-btn-primary">
              Browse &amp; book
            </Link>
            <Link to="/how-it-works" className="his-btn his-btn-outline">
              See how it works
            </Link>
          </div>

          <div className="his-cta-trust">
            {trust.map((t) => (
              <span key={t}>
                <FaCheckCircle /> {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
